var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScalable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7202 20.37H38.9702V31.62",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8501 33.49L38.9701 20.37",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0601 3.99994H15.77C15.4414 3.99861 15.1157 4.06239 14.8118 4.18756C14.5079 4.31273 14.2317 4.49684 13.9993 4.72925C13.7669 4.96166 13.5827 5.23777 13.4575 5.54168C13.3324 5.8456 13.2687 6.17126 13.27 6.49994V27.0099H18.27V9.00995H50.5601V41.29H32.5601V46.29H53.0801C53.7431 46.29 54.3788 46.0266 54.8477 45.5577C55.3165 45.0889 55.5801 44.453 55.5801 43.79V6.49994C55.5814 6.16957 55.5171 5.84225 55.3906 5.53702C55.2642 5.23178 55.0783 4.95475 54.8438 4.72207C54.6092 4.4894 54.3307 4.30571 54.0244 4.18173C53.7182 4.05775 53.3904 3.99595 53.0601 3.99994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.04 55.55H6.5C5.83696 55.55 5.20102 55.2867 4.73218 54.8178C4.26334 54.349 4 53.713 4 53.05V34.51C4 33.847 4.26334 33.2111 4.73218 32.7422C5.20102 32.2734 5.83696 32.01 6.5 32.01H25.04C25.7031 32.01 26.339 32.2734 26.8079 32.7422C27.2767 33.2111 27.54 33.847 27.54 34.51V53.05C27.54 53.713 27.2767 54.349 26.8079 54.8178C26.339 55.2867 25.7031 55.55 25.04 55.55ZM9.04004 50.55H22.5801V37.01H8.98999L9.04004 50.55Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.56,
    height: 51.55,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalable);
export default __webpack_public_path__ + "static/media/scalable.a7295d3d8c7eb7cb3e67d69541cf44fe.svg";
export { ForwardRef as ReactComponent };